module.exports = __webpack_public_path__ + "static/media/person0.f82786a1.jpeg";